import React from 'react'
import { observer, inject } from 'mobx-react'
import { NavItem } from 'react-bootstrap'
import * as linkConst from '../constants/link_constants'

const _UploadInfo = ({ store, ...rest }) => {
  const isProgress = store.progress && store.progress > 0
  const queueCount = store.queue && store.queue.length

  return queueCount > 0 && <NavItem {...rest} onClick={() => store.goTo('uploads')}>
    <span className='glyphicon glyphicon-upload' style={{ position: 'relative', top: '2px' }} />
    {store.__(linkConst.LINK_UPLOADS_TITLE_SHORT)}&nbsp;
    <span className='badge' style={{ position: 'relative', top: '-1px' }}>
      {store.activeUploads}/{queueCount}
    </span>&nbsp;
    {store.currentUpload !== null && isProgress &&
        <span>
          {store.progress}%&nbsp;
          <span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />
        </span>
    }
    {store.activeUploads > 0 && store.uploadStopped &&
        <span className='label label-danger'>{store.__('Stopped!')}</span>
    }
  </NavItem>
}

export default inject('store')(observer(_UploadInfo))
